import React from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { reduxForm } from 'redux-form';

import { scrollToInvalid } from './utils';
import ButtonComponent from '../button/ButtonComponent';
import { LoadingComponent } from '../loading/LoadingComponent';

import './FormComponent.scss';

class FormComponent extends React.Component {
    onSubmitForm = data => this.props.onSubmit(data);

    renderLoading = () => {
        const { requestSubmit } = this.props;
        if (requestSubmit) {
            return <LoadingComponent />;
        }
    };

    renderSubmitButton = () => {
        const { i18n, requestSubmit, hideButton, submitText } = this.props;
        if (!requestSubmit && !hideButton) {
            return (
                <ButtonComponent
                    type="submit"
                    color="main"
                    text={submitText ? submitText : i18n.SUBMIT}
                />
            );
        }
    };

    // Inject i18n form object into Field input
    childrenWithProps = () =>
        React.Children.map(
            this.props.children,
            child =>
                child &&
                React.cloneElement(child, {
                    i18nFeatureForm: this.props.i18n,
                    formName: this.props.name
                })
        );

    render() {
        const { handleSubmit, className, classNameInputContainer, encType } = this.props;

        return (
            <form
                className={className}
                onSubmit={handleSubmit(this.onSubmitForm)}
                encType={encType ? 'multipart/form-data' : ''}>
                <div className={classNameInputContainer}>{this.childrenWithProps()}</div>
                <div className="form-submit-container">
                    {this.renderLoading()}
                    {this.renderSubmitButton()}
                </div>
            </form>
        );
    }
}

FormComponent.propTypes = {
    className: PropTypes.string,
    classNameInputContainer: PropTypes.string,
    form: PropTypes.string.isRequired,
    children: PropTypes.arrayOf(PropTypes.element),
    onSubmit: PropTypes.func.isRequired,
    encType: PropTypes.bool,
    requestSubmit: PropTypes.bool.isRequired,
    errorSubmit: PropTypes.bool.isRequired,
    submitText: PropTypes.string,
    hideButton: PropTypes.bool
};

const mapStateToProps = state => {
    return {
        i18n: state.i18n.feature.form
    };
};

/**
 * initialValues is used by redux form to initialize input value
 * initialValues must be a valid json object with key corresponding to input Field name attribute
 */
export default connect(mapStateToProps)(
    reduxForm({ onSubmitFail: errors => scrollToInvalid(errors) })(FormComponent)
);



// WEBPACK FOOTER //
// ./src/components/form/FormComponent.js